






















































import SelectOption from "@/common/ui/presenters/select-option";
import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { getAllProjects } from "../../../api/project-api";
import { getAllCompanies } from "@/api/company-api";
import emitter from "@/EventBus";
import AccountingSearchOptions from "../presenters/accounting-search-options";
import { addMonths, format } from "date-fns";
import { cloneDeep } from "lodash";

export interface Option {
  [key: string]: SelectOption[];
}

export interface Attribute {
  required: boolean;
  disabled: boolean;
}

@Component({})
export default class AccountingSearchBar extends Vue {
  @Prop({ required: true }) mode!: string;

  date = new Date();
  options: AccountingSearchOptions = {
    projectId: "",
    companyId: "",
    status: "",
    dateType: "",
    month: format(this.date, "yyyy-MM"),
    startDate: "",
    endDate: ""
  };

  projects: SelectOption[] = [];
  companies: SelectOption[] = [];
  validation = {
    dateType: true,
    month: false
  };

  status: Option = {
    estimate: [
      {
        text: "全て(ステータス)",
        value: ""
      },
      {
        text: "見込み",
        value: "expected"
      },
      {
        text: "見積中",
        value: "created_new"
      },
      {
        text: "提出前",
        value: "created"
      },
      {
        text: "見積提出",
        value: "quoted_new"
      },
      {
        text: "提出済",
        value: "quoted"
      },
      {
        text: "受注",
        value: "success"
      },
      {
        text: "失注",
        value: "failure"
      }
    ],
    invoice: [
      {
        text: "全て(ステータス)",
        value: ""
      },
      {
        text: "未請求",
        value: "created"
      },
      {
        text: "請求済",
        value: "requested"
      },
      {
        text: "入金済",
        value: "paid"
      },
      {
        text: "無効",
        value: "invalid"
      }
    ],
    purchase: [
      {
        text: "全て(ステータス)",
        value: ""
      },
      {
        text: "未発注",
        value: "created"
      },
      {
        text: "発注済",
        value: "ordered"
      },
      {
        text: "送金済",
        value: "paid"
      },
      {
        text: "無効",
        value: "invalid"
      }
    ]
  };

  dateTypes: Option = {
    estimate: [
      {
        text: "日付指定なし",
        value: ""
      },
      {
        text: "発行日",
        value: String(1)
      },
      {
        text: "受注日",
        value: String(2)
      }
    ],
    invoice: [
      {
        text: "日付指定なし",
        value: ""
      },
      {
        text: "請求日",
        value: String(1)
      },
      {
        text: "入金予定日",
        value: String(2)
      }
    ],
    purchase: [
      {
        text: "日付指定なし",
        value: ""
      },
      {
        text: "発注日",
        value: String(1)
      },
      {
        text: "支払予定日",
        value: String(2)
      }
    ]
  };

  monthOptions: SelectOption[] = [
    {
      text: "前々月",
      value: format(addMonths(this.date, -2), "yyyy-MM")
    },
    {
      text: "前月",
      value: format(addMonths(this.date, -1), "yyyy-MM")
    },
    {
      text: "当月",
      value: format(this.date, "yyyy-MM")
    },
    {
      text: "翌月",
      value: format(addMonths(this.date, 1), "yyyy-MM")
    },
    {
      text: "翌々月",
      value: format(addMonths(this.date, 2), "yyyy-MM")
    },
    {
      text: "From～To",
      value: ""
    }
  ];

  protected created() {
    this.getDateType();
    this.initProjectList();
    this.initCompanyList();
    emitter.emit("initData", this.options);
  }

  get companyOptions() {
    return [
      {
        text: "全て(元請け)",
        value: ""
      },
      ...this.companies.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initCompanyList() {
    this.companies = (await getAllCompanies()).map(p => ({
      text: p.name,
      value: String(p.companyId)
    }));
  }

  get projectOptions() {
    return [
      {
        text: "全て(現場)",
        value: ""
      },
      ...this.projects.map(s => ({
        text: s.text,
        value: String(s.value)
      }))
    ];
  }

  private async initProjectList() {
    this.projects = (await getAllProjects()).map(p => ({
      text: p.name,
      value: String(p.projectId)
    }));
  }

  get statusOptions(): SelectOption[] {
    return this.status[this.mode];
  }

  get dateTypeOptions() {
    return this.dateTypes[this.mode];
  }

  submit() {
    if (this.checkDateRange()) {
      alert("日付指定が不正です。");

      return;
    }
    const options = cloneDeep(this.options);
    if (options.dateType == "") {
      options.month = "";
    }
    this.$emit("handleSearch", options);
  }

  @Watch("options.dateType")
  onDateTypeChanged(value: string) {
    if (value !== "" && this.options.month == "") {
      return;
    }

    if (value == "") {
      this.validation.dateType = true;
      this.validation.month = true;
      this.options.month = format(this.date, "yyyy-MM");
      this.resetDate();

      return;
    }

    this.validation.month = false;
    this.validation.dateType = true;
  }

  @Watch("options.month")
  onMonthChanged(value: string) {
    if (value == "") {
      this.validation.dateType = false;

      return;
    }
    this.validation.dateType = true;
    this.resetDate();
  }

  get validate() {
    const result: {
      [key: string]: Attribute;
    } = {};
    Object.keys(this.validation).forEach(key => {
      result[key] = {
        required: !(this.validation as any)[key],
        disabled: (this.validation as any)[key]
      };
    });
    return result;
  }

  resetDate() {
    this.options.startDate = "";
    this.options.endDate = "";
  }

  checkDateRange() {
    let { startDate, endDate } = this.options;
    if (
      new Date(startDate as string).getTime() >
      new Date(endDate as string).getTime()
    ) {
      return true;
    }

    return false;
  }

  getDateType() {
    if (!this.dateTypes) return "";
    if (this.mode == "estimate") {
      this.options.dateType = this.dateTypes[this.mode][1].value;

      return;
    }
    this.options.dateType = this.dateTypes[this.mode][2].value;

    return;
  }
}
